import React from 'react';
import Currency from '../../common/intl/Currency';
import {
  Dagger,
  Asterisk,
} from '../../common/notifications/NotificationsTrigger';
import { useNotifications } from '../../common/notifications/NotificationsContext';

export const Price = ({ children, value, className, showSign }) => {
  const sign = showSign && value > 0 ? '+' : '';

  return (
    <span className={`${className}__price`}>
      {children || (
        <>
          {sign}
          <Currency value={value} />
        </>
      )}
    </span>
  );
};

const PriceWithNotification = ({
  children,
  className = 'math-box__net-price-value disclaimer',
  value,
  onClick,
}) => (
  <div className={className} onClick={onClick}>
    {children || <Currency value={value} />}
    <Dagger className="math-box__price-dagger" />
    <Asterisk className="math-box__price-asterisk" />
  </div>
);

const PriceWithSymbol = ({ children, value, symbol, isNetPrice }) => {
  const Symbol = symbol || Dagger;
  return (
    <div
      className={`${
        isNetPrice ? 'math-box__price--net-price' : 'math-box__price'
      }`}>
      {children || <Currency value={value} />} <Symbol disabled={true} />
    </div>
  );
};

export const PriceWithConditionalNotification = (props) => {
  const {
    notificationName,
    inlineNotification,
    useModal,
    evProgramModal = null,
  } = props;
  const { disabled, showNamed, show } = useNotifications();

  if (disabled) {
    return <Price {...props} />;
  }

  if (evProgramModal) {
    return (
      <PriceWithNotification
        {...props}
        onClick={(event) => show(evProgramModal, event, null, true)}
      />
    );
  }

  if (!inlineNotification) {
    return (
      <PriceWithNotification
        {...props}
        onClick={(event) =>
          useModal
            ? showNamed(notificationName, event, true)
            : showNamed(notificationName, event)
        }
      />
    );
  }

  return <PriceWithSymbol {...props} />;
};
